import { render } from "./AnimatingNumber.vue?vue&type=template&id=45b539c4&scoped=true"
import script from "./AnimatingNumber.vue?vue&type=script&lang=js"
export * from "./AnimatingNumber.vue?vue&type=script&lang=js"

import "./AnimatingNumber.vue?vue&type=style&index=0&id=45b539c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b539c4"]])

export default __exports__